module.exports = __webpack_public_path__ + "img/Peddrew at commencement.651b6d6d.jpg";